export enum TenantSearchMode {
  Algolia = 'Algolia',
  AI = 'AI',
}
